export default {
  NotTakenAction: '조치 대기',
  Action: '조치 완료',
};
